export default function truncateDecimal(num, fixed) {
	// eslint-disable-next-line
	let re = new RegExp(`^-?\\d+(?:\.\\d{0,${fixed || -1}})?`);
	return Number.parseFloat(num.toString().match(re)[0]).toFixed(fixed);
}